<template>
    <div>
      <el-tabs v-model="activeName" class="right-tabs" :stretch="true">
        <el-tab-pane label="组件属性" name="first">
          <!-- 普通表格 -->
          <normal-table v-if="activeData.layout == 'normalTableItem'" :pageId="pageId" :activeData="activeData" :pageTemp="pageTemp" @refreshTableStyle="refreshTableStyle"></normal-table>
          <!-- 列表单元素 -->
          <col-form v-if="activeData.layout == 'colFormItem'" :pageId="pageId" :activeData="activeData" :pageTemp="pageTemp"></col-form>
        </el-tab-pane>
        <el-tab-pane label="页面属性" name="second">
          <el-form size="small" label-width="90px" label-suffix="：">
            <el-form-item label="主键字段">
                <el-input v-model="pageTemp.primaryKey" placeholder="请输入主键字段" />
            </el-form-item>
            <el-form-item :label="dataServerKeyLabel1">
                <el-input v-model="pageTemp.dataServerKey1" placeholder="service_key1" />
            </el-form-item>
            <el-form-item :label="dataServerKeyLabel2">
                <el-input v-model="pageTemp.dataServerKey2" placeholder="service_key2" />
            </el-form-item>
            <el-form-item label="标签宽度">
                <el-input-number v-model="pageTemp.labelWidth" placeholder="标签宽度" />
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      </div>
</template>
<script>
  import NormalTable from "./item/normalTable.vue";
  import ColForm from "./item/colForm.vue";

  export default {
    name: "RightPanel",
    props: {
      pageId: String,
      activeData: {
        type: Object,
        default: function(){
          return{
            itemType: '',
            layout: ''
          }
        }
      },
      pageTemp: {
        type: Object,
        default: function(){
          return{
            labelWidth: ''
          }
        }
      }
    },
    watch: {
      //页面模板类型
      'pageTemp.pageTemplate': function (newVal){
        console.log('新的newValue:' + newVal);
        if(newVal === 'save'){
          this.dataServerKeyLabel1 = '保存接口key';
          this.dataServerKeyLabel2 = '页面信息key';
        }else{
          this.dataServerKeyLabel1 = 'service_key1';
          this.dataServerKeyLabel2 = 'service_key2';
        }
      }
    },
    created() {
      let pageTemplate = this.pageTemp.pageTemplate;

    },
    data(){
      return {
        pageType: '',                          //页面类型
        activeName: 'first',                   //默认第一个
        dataServerKeyLabel1: 'service_key1',   //默认第一个
        dataServerKeyLabel2: 'service_key2',   //默认第一个
      }
    },
    components: {
      NormalTable,
      ColForm
    },
    methods: {
      //刷新表格样式
      refreshTableStyle(){
        this.$emit('refreshTableStyle')
      }
    }
  }
</script>
<style scoped>
  .right-tabs{height: 45px;}
</style>



// WEBPACK FOOTER //
// src/components/PageDesigner/RightPanel.vue